<script setup>
/**
 * SupportChat - A support chat component
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 * @version 1.0
 */

import { sendMessage, login } from '@/services/chat'

import { onMounted, ref, computed, watch } from 'vue'
import { flatten } from 'lodash'

const DISPLAY_TIMEOUT = 500

const menuVisible = ref(false)
const userMessage = ref("")
const loading = ref(false)
const userInput = ref(null)
const loggedIn = ref(false)
const chatWidget = ref({})
const chatConversation = ref([])

const newEntries = computed(() =>
  flatten(
    chatConversation.value.map(({ ai, human }) =>
        [{ text: human, user: true }, { text: ai, ai: true }]
      )
  )
)

function hideMenu() {
	menuVisible.value = false
}

function SendMessage() {
  const text = userMessage.value
  // chatConversation.value.push({ human: `${text}` })
  userMessage.value = ""
	loading.value = true
  sendMessage({ text, conversation: chatConversation.value })
		.then(({ response, message, userInput, conversation }) => {
      chatConversation.value = [...conversation]
		})
		.finally(() => {
			loading.value = false
			hideMenu()
			setTimeout(() => { menuVisible.value = true }, 500)
		})
}

function focusTextArea() {
	setTimeout(() => {
		userInput.value && userInput.value.$el.focus()
	}, 100)
}

function chatLogin() {
	return login()
    .then(({ widget, user, ...data }) => {
      loggedIn.value = true
      chatWidget.value = widget
    })
}

function resetChat() {
  chatConversation.value = []
  hideMenu()
  setTimeout(() => { menuVisible.value = true }, 500)
}


onMounted(() => {
  chatLogin()
	setTimeout(() => {
		menuVisible.value = true
	}, DISPLAY_TIMEOUT)
})

watch(menuVisible, async () => {
	focusTextArea()
})

</script>

<template>
  <md-menu
      :md-active.sync="menuVisible"
    md-direction="top-start"
    md-size="small"
    >          <md-button md-menu-trigger class="md-simple md-size-3x md-primary just-icon">
	    <md-icon class="md-size-2x"> contact_support</md-icon>
          </md-button>
          <md-menu-content class="menu-chat-content">
		  <md-menu-item class="text-center">
        <!-- <img :src="chatWidget.imagePath"> -->
			  <md-icon class="md-size-3x text-center chat-icon" :class="loggedIn && !loading ? 'md-primary' : ''">
				  {{ loggedIn ? 'contact_support' : 'error' }}
			  </md-icon>
        <p class="chat-text system-text">
          {{ chatWidget.message }}
        </p>
			  <md-button @click="login" class="md-just-icon md-simple md-primary"
				  v-if="!loggedIn">
				  <md-icon> refresh </md-icon>
			  </md-button>
			  </md-content>
		  </md-menu-item>
	    <md-menu-item class="chat-entry"
		    v-for="entry, i in newEntries" :key="i" 
		    >
        <span class="md-caption">
          {{entry.user ? 'Yo:' : `${chatWidget.name}:`}}
        </span>
		    <p class="chat-text"
				    :class="entry.user ? 'user-text md-caption' : 'system-text'"
            v-html="entry.text">

		    </p>
	    </md-menu-item>

	    <md-menu-item class="chat-progress" v-show="loading">
		    <div class="progress-container">
			    <md-progress-spinner
					    class="md-accent chat-progress-spinner"
					    md-mode="indeterminate"
					    ></md-progress-spinner>
		    </div>
	    </md-menu-item>

      <md-menu-item v-show="!loading && chatConversation.length > 0">
        <md-button class="md-simple" @click="resetChat">
          <md-icon> refresh </md-icon>
          Reiniciar
        </md-button>
	    </md-menu-item>

	    <md-menu-item v-show="!loading">
		    <md-field md-clearable>
			    <label for="userMessage" v-show="loggedIn && userMessage.length <= 0"> Escribe un mensaje </label>
			    <md-icon v-show="userMessage.length > 0"> forum </md-icon>
			    <md-textarea :disabled="!loggedIn"
				    v-model="userMessage" md-autogrow
				    @keyup.enter="SendMessage" ref="userInput" autofocus
			    />
			    <md-icon> contact_support </md-icon>
		    </md-field>
	    </md-menu-item>
	  </md-menu-content>
  </md-menu>
</template>

<style scoped>
.chat-text {
  text-wrap-mode: wrap;
}
.user-text  {
	text-align: right;
	font-weight: bold;
}

.system-text {
	text-align: left;
	background-color: #e8eBeC; /* Light gray background */
	border-radius: 24px;       /* Rounded corners */
	padding: 8px;             /* Padding to give space around the text */
	display: inline-block;     /* Ensures the background doesn't span the full width */
	word-break: normal;
}

i.md-icon.chat-icon {
	margin-left: auto;
	margin-right: auto;
}
.chat-entry.md-list-item {
	margin-bottom: 2px;
	line-height: unset;
	height: unset;
	max-height: 1000px;
	min-height: 20px;
}

.progress-container {
	justify-content: center;
}

.menu-chat-content.md-menu-content {
  max-height: 90vh;
}

</style>





// WEBPACK FOOTER //
// SupportChat.vue